import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { InspirationFeed } from '@/components/demand/InspirationFeed';
export default function InspirationFeedPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Head><title>Inspiration Feed | Sizzle</title><meta name="description" content="See what worked, why it worked, and what to post next. Real demand generation examples from CPG brands." /></Head><InspirationFeed /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}